export function useDashboardEvents() {
  const getAllEvents = async () => {
    const res = await $fetch(`/api/v1/dashboard-events`, {
      method: 'GET',
    })
    return res
  }

  const createEvent = async (body: any) => {
    const res = await $fetch(`/api/v1/dashboard-events`, {
      method: 'POST',
      body: body,
    })
    return res
  }

  const updateEvent = async (body: any) => {
    const res = await $fetch(`/api/v1/dashboard-events/${body.id}`, {
      method: 'PUT',
      body: body,
    })
    return res
  }

  const deleteEvent = async (eventId: string) => {
    const res = await $fetch(`/api/v1/dashboard-events/${eventId}`, {
      method: 'DELETE',
    })
    return res
  }
  return {
    getAllEvents,
    createEvent,
    deleteEvent,
    updateEvent,
  }
}
